import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackComponent } from './pages/callback/callback.component';
import { RestrictedComponent } from './pages/restricted/restricted.component';
import { SignOutComponent } from './pages/sign-out/sign-out.component';
import { MaintenanceModeModule } from './maintenance-mode/maintenance-mode.module';
import { MaintenanceModeService } from './maintenance-mode/maintenance-mode.service';

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'restricted',
    component: RestrictedComponent,
  },
  {
    path: 'signout',
    component: SignOutComponent,
  },
  { path: '', redirectTo: '/categories', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    MaintenanceModeModule,
  ],
  exports: [RouterModule],
  providers: [MaintenanceModeService],
})
export class AppRoutingModule {}
